import httpService from "..";
import { RequiredDocumentKey, ComplianceCardKey } from "../../utils/documentCompliance";

export interface ComplianceRow {
  id: number | string;
  IdNumber: string;
  PolicyNumber: string;
  Name: string;
  Surname: string;
  ProductID: number | null;
  ProductName: string;
  AgeDays: number | null;
  Detail: string;
  /** Approximate months behind on premium (LapseRisk enrichment). */
  MonthsBehind?: number | null;
  /** DebiCheck incomplete severity (error | pending | incomplete). */
  Severity?: "error" | "pending" | "incomplete" | null;
  MissingDocuments: RequiredDocumentKey[];
  MemberID?: number | null;
  ClaimID?: number | string | null;
  ClaimNumber?: string;
  ViewPath: string;
}

export interface ComplianceCard {
  Key: ComplianceCardKey;
  Label: string;
  Description: string;
  MissingCount: number;
  Members: ComplianceRow[];
}

export interface ComplianceProductOption {
  id: number;
  name: string;
}

export interface DocumentComplianceData {
  TotalMembers: number;
  ActiveMembers: number;
  ScannedMembers: number;
  FailedMembers: number;
  Truncated: boolean;
  Products: ComplianceProductOption[];
  Documents: ComplianceCard[];
}

export interface GetDocumentComplianceParams {
  productId?: number | null;
  recentLapseDays?: number;
  /** Cache-bust so intermediaries cannot serve a stale compliance body. */
  cacheBust?: boolean;
}

/**
 * Group compliance dashboard — served by GET /compliance/group/:groupId
 */
export const getDocumentComplianceApi = async (
  groupId: string,
  params: GetDocumentComplianceParams = {}
) => {
  const query = new URLSearchParams();
  query.set("recentLapseDays", String(params.recentLapseDays ?? 90));
  if (params.productId != null) {
    query.set("productId", String(params.productId));
  }
  if (params.cacheBust !== false) {
    query.set("_t", String(Date.now()));
  }

  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/compliance/group/${groupId}?${query.toString()}`,
    "get"
  );
};

// Aliases kept for existing imports
export type NonCompliantMember = ComplianceRow;
export type DocumentComplianceCard = ComplianceCard;
